import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';
import { FaQuestionCircle } from 'react-icons/fa';

function HelpPopup({
  helpKey,
  placement,
  trigger,
  content,
}: {
  helpKey: string,
  placement: 'right' | 'left',
  trigger: OverlayTriggerType | OverlayTriggerType[] | undefined,
  content: JSX.Element,
}): JSX.Element {
  return (
    <OverlayTrigger
      key={helpKey}
      placement={placement}
      trigger={trigger}
      delay={{ show: 250, hide: 1500 }}
      overlay={(
        <Tooltip id="{key}-tooltip">
          {content}
        </Tooltip>
      )}
    >
      <div className="icon-tooltip">
        <FaQuestionCircle />
      </div>
    </OverlayTrigger>
  );
}

export default HelpPopup;
